import { render } from "./NewOrder.vue?vue&type=template&id=4985122c&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"

import "./NewOrder.vue?vue&type=style&index=0&id=4985122c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4985122c"]])

export default __exports__